import { WorldWordmark } from "./WorldPrimitives";

const SUPPORTING_LINKS = [
  { href: "/privacy", label: "Privacy" },
  { href: "/terms", label: "Terms" },
  { href: "/faq", label: "FAQ" },
];

export function SupportingHeader({ currentPath = "" }) {
  return (
    <header className="tgc-supporting-header">
      <a className="tgc-supporting-brand" href="/" aria-label="The Gift Conversation home">
        <WorldWordmark />
      </a>
      <nav className="tgc-supporting-nav" aria-label="Supporting information">
        {SUPPORTING_LINKS.map((link) => (
          <a
            key={link.href}
            href={link.href}
            aria-current={currentPath === link.href ? "page" : undefined}
          >
            {link.label}
          </a>
        ))}
      </nav>
    </header>
  );
}

export function SupportingFooter() {
  return (
    <footer className="tgc-supporting-footer">
      <div>
        <WorldWordmark />
        <small>© 2026 The Gift Conversation, LLC.</small>
      </div>
      <nav className="tgc-supporting-footer-nav" aria-label="Footer">
        {SUPPORTING_LINKS.map((link) => (
          <a key={link.href} href={link.href}>{link.label}</a>
        ))}
        <a href="mailto:support@thegiftconversation.com">Contact</a>
      </nav>
    </footer>
  );
}
